import React, { useContext } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import Barcode from 'react-barcode';
import { LocalizationContext } from '../localization/LocalizationContext';

function LoyaltyQrCard({ cardNumber, name }) {
  const { translations } = useContext(LocalizationContext);
  const loc = translations.loyaltyQr || {};

  if (!cardNumber) return null;

  return (
    <div className="loyalty-qr-card">
      {name && <div className="loyalty-qr-name">{name}</div>}
      <div className="loyalty-qr-code">
        <QRCodeSVG value={String(cardNumber)} size={240} level="M" marginSize={2} />
      </div>
      <div className="loyalty-qr-barcode">
        <Barcode
          value={String(cardNumber)}
          format="CODE128"
          width={2}
          height={70}
          displayValue={true}
          fontSize={14}
          margin={8}
        />
      </div>
      <div className="loyalty-qr-number">
        {(loc.cardNumber || 'Card Number')}: {cardNumber}
      </div>
    </div>
  );
}

export default LoyaltyQrCard;
